import styled from "styled-components";

export const Style = styled.div`
  h3 {
    font-size: 18px;
    font-weight: 500;
    color: #001529;
  }

  .w-p {
    padding: 0 var(--size-lg);
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0 var(--size-lg);
    margin-top: 26px;
    margin-bottom: 26px;
    
    .info-row {
      display: flex;
      justify-content: space-between;
    
      p {
        margin-bottom: 0px;
        color: #344054;
        font-size: var(--font-size-lg);
        font-weight: 500;
      }
    }
  }

  .g2-tooltip {
    opacity: 1 !important;
  }

  .sca-graph-tooltip {
    min-width: 140px;
    padding: 12px 0px;
    display: flex;
    flex-direction: column;

    .tooltip-header {
      margin-bottom: 14px;

      h3 {
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 5px;
      }

      h4 {
        font-size: 12px;
        font-weight: 500;
        margin-bottom: 5px;
        color: var(--color-primary-70);
      }

      h5 {
        font-size: 12px;
        margin-bottom: 0px;
        font-weight: 300;
      }
    }

    .items {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .item { 
        display: flex;
        gap: 6px;

        .cont {
          display: flex;

          flex-direction: column;
          justify-content: center;

          label {
            margin-bottom: 0px;
            font-weight: 500;
          }

          .legend {
            width: 10px;
            height: 10px;
            border-radius: 100%;
          }

          &.label {
            flex: 1;

            label {
              font-size: 12px;
              color: #001529;
            }
          }

          &.value {
            label {
              font-size: 14px;
              color: #001529;
            }
          }
        }
      }
    }
  }

`;

